import styled from "@emotion/styled";
import { tooltipClasses } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";

export const LightTooltip = styled(({ className, ...props }) => (
	<Tooltip
		{...props}
		slotProps={{
			popper: {
				modifiers: [
					{
						name: "offset",
						options: {
							offset: [0, -14],
						},
					},
				],
			},
		}}
		classes={{ popper: className }}
	/>
))(({ theme }) => ({
	[`& .${tooltipClasses.arrow}`]: {
		color: theme.palette.common.white,
	},
	[`& .${tooltipClasses.tooltip}`]: {
		backgroundColor: theme.palette.common.white,
		color: "rgba(0, 0, 0, 0.87)",
		boxShadow: theme.shadows[1],
		fontSize: 14,
		padding: "5px 10px",
	},
}));
